import React from 'react'
import carteirasleft from '../../../../assets/carteirasleft.png'
import './style.css'

export default function Info4() {

    const title = 'Quem pode solicitar o documento de estudante?'
    const info2 = 'Estudantes matriculados em cursos presenciais ou a distância (EAD) podem solicitar o Documento do Estudante para garantir o direito à meia-entrada em shows, eventos e cinemas. O benefício está disponível para alunos regularmente inscritos em qualquer uma das seguintes modalidades de ensino: Fundamental, Médio, Técnico, Superior, Mestrado e Doutorado.'

    return (
        <div className='containerhome2'>
            <div className='home2left'>
                <img src={carteirasleft} />
            </div>
            <div className='home2right'>
                
                <h1 className='tituloInfohome2'><b>{title}</b></h1>
                <div className='linha'></div>
                <h3 className='infohome2'>{info2}</h3> 
            </div>
            
        </div>
    )
}
